import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b1d4502"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover" }
const _hoisted_2 = ["data-edit", "innerHTML"]

import { withDefaults } from 'vue';

import { vMove, vInput, useCover } from './index';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1348.365 1419.766">
  <g transform="translate(1.254 -89)">
    <g id="fengmian5">
      <path d="M-16541.053-6774.65l138.15,154.7-138.15,154.491h-488.174V-6774.65Z" transform="translate(17029.227 7909)" fill="var(--theme-color-1)"/>
      <path d="M-16487.465-6773.994h683.208v150.174h-548.758Z" transform="translate(16999.258 7908)" fill="var(--theme-color-1)"/>
      <path d="M-14993.666-7990l21.639,28.552-21.639,26.045h-277.588V-7990Z" transform="translate(15270 8079)" fill="var(--theme-color-1)"/>
      <path d="M-15219.615-7990l-21.639,28.552,21.639,26.045h277.588V-7990Z" transform="translate(16135.281 8079)" fill="var(--theme-color-1)"/>
      <path d="M-16098.762-6601.751h212.736l-121.941,137.1h-216.377Z" transform="translate(16736.137 7908.187)" fill="#26292e"/>
      <path d="M-16098.762-6601.751h472.736l-121.941,137.1h-476.377Z" transform="translate(16973.137 7908.187)" fill="#26292e"/>
    </g>
    <line x2="667" transform="translate(262.5 1507.266)" fill="none" stroke="#8e8e8e" stroke-width="3"/>
  </g>
</svg>

`;


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-cover-5',
  props: {
    useEdit: { type: Boolean },
    projectName: {},
    time: {},
    mainPageEnterpriseName: {},
    titlePosition: {},
    settleTimePosition: {},
    aspNamePosition: {},
    orderNumber: {},
    orderNumberPostion: {}
  },
  emits: ['posChange', 'valueChange'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { info, onPosChange, onValueChange } = useCover(emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info), (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        "data-edit": _ctx.useEdit,
        key: index,
        class: _normalizeClass({ [item.className]: true }),
        innerHTML: props[item.valueKey]
      }, null, 10, _hoisted_2)), [
        [_unref(vMove), {
        pos: props[item.posKey],
        change: (left, top) => _unref(onPosChange)(item.posKey, left, top)
      }],
        [_unref(vInput), {
        value: props[item.valueKey],
        change: (value) => _unref(onValueChange)(item.valueKey, value)
      }]
      ])
    }), 128)),
    _createElementVNode("div", {
      innerHTML: svg,
      class: "svg"
    })
  ]))
}
}

})